export const BILLING = '/billing';
export const CALENDAR = '/calendar';
// TODO: Modify CONVERSATION route so that it does not conflict with API.
export const CONVERSATION = '/tasks/:taskId/conversation';
export const FORGOT_PASSWORD = '/forgot-password';
export const LOGIN = '/login';
export const LOGOUT = '/logout';
export const MESSENGER = '/messenger';
export const PEOPLE = '/people';
export const PAYMENTS = '/payments';
export const PAYMENTS_ONBOARDING = '/payments-onboarding';
export const PAYOUTS = '/payouts';
export const REQUEST_UNLOCK = '/request-unlock';
export const RESET_PASSWORD = '/reset-password';
export const REVIEWS = '/reviews';
export const REVIEW_SETTINGS = '/review-settings';
export const SETTINGS = '/settings';
export const SIGNUP = '/signup';
export const UNLOCK = '/unlock';
export const WEBSITE = '/website';
export const WORKFLOW = '/workflow';
